import React, { useEffect } from "react";
import Header from "../components/Header";
import Minibanner from "../components/Minibanner";
import Banner from "../components/Banner";
import Categorys from "../components/Categorys";
import Typearticles from "../components/Typearticles";
import Brands from "../components/Brands";
import FeatureProducts from "../components/products/FeatureProducts";
import Products from "../components/products/Products";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { get_products } from "../store/reducers/homeReducer";
import useGuestId from "../hooks/useGuestId";
import { PropagateLoader } from "react-spinners";

const Home = () => {
  useGuestId(); // Genera guestId si no existe
  const dispatch = useDispatch();

  const { latest_product, topRequest_product, discount_product, categorys, categorys_loading } = useSelector(state => state.home);

  useEffect(() => {
    dispatch(get_products());
  }, [dispatch]);

  return (
    <div>
      <Header />
      <Minibanner />
      <Banner />
      <Brands />
      <div className="py-[45px]">
        <FeatureProducts products={latest_product} />
      </div>
      <Typearticles />
      {categorys_loading && categorys.length === 0 ? (
        <div className="w-full flex justify-center items-center py-10">
          <PropagateLoader color={"#ae1d22"} />
        </div>
      ) : (
        <Categorys categorys={categorys} />
      )}
      <div className="py-[45px]">
        <Products title="LO MÁS VENDIDO" products={topRequest_product} />
      </div>

      <div className="py-[45px]">
        <Products title="PRODUCTO CON DESCUENTOS" products={discount_product} />
      </div>

      <Footer />
    </div>
  );
};

export default Home;
